// import React, { useContext, useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useCart } from '../context/CartContext';
// import { AuthContext } from '../context/AuthContext';
// import { useTheme } from '../context/ThemeContext';
// import API from '../api/axios';
// import '../style/Header.css';
// import logoDark from '../assests/InvoiceLOGO.jpeg';
// import logoLight from '../assests/InvoiceLOGO.jpeg';

// const Header = () => {
//   const { cart } = useCart();
//   const { user, logout } = useContext(AuthContext);
//   const { darkMode, toggleTheme } = useTheme();
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [adminDropdownOpen, setAdminDropdownOpen] = useState(false);
//   const [categories, setCategories] = useState([]);
//   const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);


//   const navigate = useNavigate();
//   const logo = darkMode ? logoDark : logoLight;

//   const handleLogout = () => {
//     logout();
//     navigate('/');
//   };

//   const toggleMenu = () => setMenuOpen(prev => !prev);

//   const closeAllMenus = () => {
//     setMenuOpen(false);
//     setAdminDropdownOpen(false);
//     setCategoryDropdownOpen(false);
//   };

//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const res = await API.get('/categories');
//         setCategories(res.data);
//       } catch (err) {
//         console.error("Failed to fetch categories", err);
//       }
//     };
//     fetchCategories();
//   }, []);

//   return (
//     <header className={`header ${darkMode ? 'dark' : 'light'}`}>
//       <div className="header-content">
//         <div className="left-section">
//           <Link to="/" className="logo-link">
//             <img src={logo} alt="Logo" className="logo" />
//           </Link>
//           <div className="hamburger" onClick={toggleMenu}>
//             ☰
//           </div>
//         </div>

//         <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
//           <Link to="/" onClick={closeAllMenus}>Home</Link>

//           {/* {categories.length > 2 && (
//             <div className="dropdown" onMouseLeave={closeAllMenus}>
//               <span className="dropdown-toggle">Categories ⬇</span>
//               <div className="dropdown-menu">
//                 {categories.map(cat => (
//                   <Link key={cat.name} to={`/category/${cat.name}`} onClick={closeAllMenus}>
//                     {cat.label}
//                   </Link>
//                 ))}
//               </div>
//             </div>
//           )} */}

//           {categories.length > 2 && (
//             <div className="dropdown">
//               <span
//                 className="dropdown-toggle"
//                 onClick={() => setCategoryDropdownOpen(prev => !prev)}
//               >
//                 Categories ⬇
//               </span>
//               {categoryDropdownOpen && (
//                 <div className="dropdown-menu">
//                   {categories.map(cat => (
//                     <Link key={cat.name} to={`/category/${cat.name}`} onClick={closeAllMenus}>
//                       {cat.label}
//                     </Link>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}


//           {/* {user?.role === 'admin' && (
//             <div
//               className="dropdown"
//               onMouseEnter={() => setAdminDropdownOpen(true)}
//               onMouseLeave={() => setAdminDropdownOpen(false)}
//             >
//               <span className="dropdown-toggle">Admin ⬇</span>
//               {adminDropdownOpen && (
//                 <div className="dropdown-menu">
//                   <Link to="/admindashboard" onClick={closeAllMenus}>Dashboard</Link>
//                   <Link to="/admin/orders" onClick={closeAllMenus}>Orders</Link>
//                   <Link to="/admin/orderupdate" onClick={closeAllMenus}>Order Update Panel</Link>
//                   <Link to="/admin/banners" onClick={closeAllMenus}>Banner Manager</Link>
//                   <Link to="/admin/promo" onClick={closeAllMenus}>Promo Management</Link>
//                   <Link to="/admin/categories" onClick={closeAllMenus}>Category Management</Link>
//                 </div>
//               )}
//             </div>
//           )} */}

//           {user?.role === 'admin' && (
//             <div className="dropdown">
//               <span
//                 className="dropdown-toggle"
//                 onClick={() => setAdminDropdownOpen(prev => !prev)}
//               >
//                 Admin ⬇
//               </span>
//               {adminDropdownOpen && (
//                 <div className="dropdown-menu">
//                   <Link to="/admindashboard" onClick={closeAllMenus}>Dashboard</Link>
//                   <Link to="/admin/orders" onClick={closeAllMenus}>Orders</Link>
//                   <Link to="/admin/orderupdate" onClick={closeAllMenus}>Order Update Panel</Link>
//                   <Link to="/admin/banners" onClick={closeAllMenus}>Banner Manager</Link>
//                   <Link to="/admin/promo" onClick={closeAllMenus}>Promo Management</Link>
//                   <Link to="/admin/categories" onClick={closeAllMenus}>Category Management</Link>
//                 </div>
//               )}
//             </div>
//           )}


//           <Link to="/cart" onClick={closeAllMenus}>🛒 Cart ({cart.length})</Link>
//           <Link to="/myorders" onClick={closeAllMenus}>📦 My Orders</Link>

//           {!user ? (
//             <>
//               <Link to="/login" onClick={closeAllMenus}>Login</Link>
//               <Link to="/register" onClick={closeAllMenus}>Register</Link>
//             </>
//           ) : (
//             <button onClick={handleLogout} className="logout-btn">Logout</button>
//           )}

//           <button className="theme-toggle-btn" onClick={toggleTheme}>
//             {darkMode ? '☀️' : '🌙'}
//           </button>
//         </nav>
//       </div>
//     </header>
//   );
// };

// export default Header;



import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { AuthContext } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import API from "../api/axios";
import "../style/Header.css";
import logoDark from "../assests/InvoiceLOGO.jpeg";
import logoLight from "../assests/InvoiceLOGO.jpeg";
import searchIcon from "../assests/searchLogo.png"; //by rajan
const Header = () => {
  const { cart } = useCart();
  const { user, logout } = useContext(AuthContext);
  const { darkMode, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const [adminDropdownOpen, setAdminDropdownOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const adminDropdownRef = useRef(null);
  const categoryDropdownRef = useRef(null);

  const navigate = useNavigate();
  const logo = darkMode ? logoDark : logoLight;

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const closeAllMenus = () => {
    setMenuOpen(false);
    setAdminDropdownOpen(false);
    setCategoryDropdownOpen(false);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?query=${encodeURIComponent(searchQuery.trim())}`);
      closeAllMenus();
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await API.get("/categories");
        setCategories(res.data);
      } catch (err) {
        console.error("Failed to fetch categories", err);
      }
    };
    fetchCategories();
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        adminDropdownRef.current &&
        !adminDropdownRef.current.contains(event.target)
      ) {
        setAdminDropdownOpen(false);
      }
      if (
        categoryDropdownRef.current &&
        !categoryDropdownRef.current.contains(event.target)
      ) {
        setCategoryDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Mobile cart total items & price
  const cartTotalItems = cart.reduce((sum, item) => sum + item.qty, 0);
  const cartTotalPrice = cart.reduce((sum, item) => sum + item.price * item.qty, 0);

  // return (
  //   <>
  //     <header className={`header ${darkMode ? "dark" : "light"}`}>
  //       <div className="header-content">
  //         <div className="left-section">
  //           <Link to="/" className="logo-link">
  //             <img src={logo} alt="Logo" className="logo" />
  //           </Link>
  //           <div className="hamburger" onClick={toggleMenu}>
  //             ☰
  //           </div>
  //         </div>

  //         <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
  //           {/* Search bar */}
  //           <form className="header-search" onSubmit={handleSearchSubmit}>
  //             <input
  //               type="text"
  //               placeholder="Search products..."
  //               value={searchQuery}
  //               onChange={(e) => setSearchQuery(e.target.value)}
  //             />
  //             <button type="submit">Submit</button>
  //           </form>

  //           <Link to="/" onClick={closeAllMenus}>Home</Link>

  //           {categories.length > 2 && (
  //             <div className="dropdown" ref={categoryDropdownRef}>
  //               <span
  //                 className="dropdown-toggle"
  //                 onClick={() => {
  //                   setCategoryDropdownOpen((prev) => !prev);
  //                   if (!categoryDropdownOpen) setAdminDropdownOpen(false); // close Admin if Categories opened
  //                 }}
  //               >
  //                 Categories ⬇
  //               </span>
  //               {categoryDropdownOpen && (
  //                 <div className="dropdown-menu">
  //                   {categories.map((cat) => (
  //                     <Link
  //                       key={cat.name}
  //                       to={`/category/${cat.name}`}
  //                       onClick={closeAllMenus}
  //                     >
  //                       {cat.label}
  //                     </Link>
  //                   ))}
  //                 </div>
  //               )}
  //             </div>
  //           )}

  //           {user?.role === "admin" && (
  //             <div className="dropdown" ref={adminDropdownRef}>
  //               <span
  //                 className="dropdown-toggle"
  //                 onClick={() => {
  //                   setAdminDropdownOpen((prev) => !prev);
  //                   if (!adminDropdownOpen) setCategoryDropdownOpen(false); // close Categories if Admin opened
  //                 }}
  //               >
  //                 Admin ⬇
  //               </span>
  //               {adminDropdownOpen && (
  //                 <div className="dropdown-menu">
  //                   <Link to="/admindashboard" onClick={closeAllMenus}>
  //                     Dashboard
  //                   </Link>
  //                   <Link to="/admin/orders" onClick={closeAllMenus}>
  //                     Orders
  //                   </Link>
  //                   <Link to="/admin/orderupdate" onClick={closeAllMenus}>
  //                     Order Update Panel
  //                   </Link>
  //                   <Link to="/admin/banners" onClick={closeAllMenus}>
  //                     Banner Manager
  //                   </Link>
  //                   <Link to="/admin/promo" onClick={closeAllMenus}>
  //                     Promo Management
  //                   </Link>
  //                   <Link to="/admin/categories" onClick={closeAllMenus}>
  //                     Category Management
  //                   </Link>
  //                 </div>
  //               )}
  //             </div>
  //           )}

  //           <Link to="/cart" onClick={closeAllMenus}>
  //             🛒 Cart ({cart.length})
  //           </Link>
  //           <Link to="/myorders" onClick={closeAllMenus}>📦 My Orders</Link>

  //           {!user ? (
  //             <>
  //               <Link to="/login" onClick={closeAllMenus}>Login</Link>
  //               <Link to="/register" onClick={closeAllMenus}>Register</Link>
  //             </>
  //           ) : (
  //             <button onClick={handleLogout} className="logout-btn">Logout</button>
  //           )}

  //           <button className="theme-toggle-btn" onClick={toggleTheme}>
  //             {darkMode ? "☀️" : "🌙"}
  //           </button>
  //         </nav>
  //       </div>
  //     </header>
  // by rajan  below code
  return (
    <>
      <header className={`header ${darkMode ? "dark" : "light"}`}>
        <div className="header-container-target">
          {/* 1. Left Section: Logo & Brand Tagline */}
          <div className="brand-section">
            <Link to="/" className="logo-link">
              <img src={logo} alt="Logo" className="header-logo" />
            </Link>
            <div className="brand-text">
              <h2 className="brand-title">SS Robotics</h2>
              <span className="brand-subtitle">Smarter Automation. A Better Tomorrow.</span>
            </div>
            <div className="hamburger" onClick={toggleMenu}>☰</div>
          </div>

          {/* 2. Middle Section: Pill Search Bar */}
          <form className="pill-search-form" onSubmit={handleSearchSubmit}>
            <input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pill-search-input"
            />
            {/* <button type="submit" className="pill-search-btn">🔍</button> */}
            <button type="submit" className="pill-search-btn">
              <img src={searchIcon} alt="Search" style={{ width: '14px', height: '14px', objectFit: 'contain' }} />
            </button>
            {/* by rajan */}
          </form>

          {/* 3. Right Section: Navigation Links */}
          <nav className={`target-nav-links ${menuOpen ? "open" : ""}`}>
            {/* <Link to={user ? "/home" : "/"} onClick={closeAllMenus} className="nav-item">
              Home
            </Link> */}
            <Link to={user ? "/" : "/land"} onClick={closeAllMenus} className="nav-item">
              Home
            </Link>
            {/*  Admin Menu Dropdown (Only visible if logged in user has role === 'admin') */}
            {user?.role === "admin" && (
              <div className="dropdown" ref={adminDropdownRef}>
                <span
                  className="nav-item dropdown-toggle"
                  onClick={() => {
                    setAdminDropdownOpen((prev) => !prev);
                    if (!adminDropdownOpen) setCategoryDropdownOpen(false); // Close category dropdown if admin opens
                  }}
                >
                  Admin ▾
                </span>

                {adminDropdownOpen && (
                  <div className="dropdown-menu">
                    <Link to="/admindashboard" onClick={closeAllMenus}>
                      Dashboard
                    </Link>
                    <Link to="/admin/orders" onClick={closeAllMenus}>
                      Orders
                    </Link>
                    <Link to="/admin/orderupdate" onClick={closeAllMenus}>
                      Order Update Panel
                    </Link>
                    <Link to="/admin/banners" onClick={closeAllMenus}>
                      Banner Manager
                    </Link>
                    <Link to="/admin/promo" onClick={closeAllMenus}>
                      Promo Management
                    </Link>
                    <Link to="/admin/categories" onClick={closeAllMenus}>
                      Category Management
                    </Link>
                  </div>
                )}
              </div>
            )}
            {categories.length > 0 && (
              <div className="dropdown" ref={categoryDropdownRef}>
                <span
                  className="nav-item dropdown-toggle"
                  onClick={() => {
                    setCategoryDropdownOpen((prev) => !prev);
                    if (!categoryDropdownOpen) setAdminDropdownOpen(false);
                  }}
                >
                  Categories ▾
                </span>
                {categoryDropdownOpen && (
                  <div className="dropdown-menu">
                    {categories.map((cat) => (
                      <Link key={cat.name} to={`/category/${cat.name}`} onClick={closeAllMenus}>
                        {cat.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            )}

            <Link to="/cart" onClick={closeAllMenus} className="nav-item">
              Cart ({cart.length})
            </Link>
            <Link to="/myorders" onClick={closeAllMenus} className="nav-item">
              My Orders
            </Link>

            {!user ? (
              <div className="auth-nav-buttons">
                <Link to="/login" onClick={closeAllMenus} className="nav-item login-link">
                  Login
                </Link>
                <Link to="/register" onClick={closeAllMenus} className="register-pill-btn">
                  Register
                </Link>
              </div>
            ) : (
              <button onClick={handleLogout} className="logout-btn">Logout</button>
            )}

            {/* <button className="theme-toggle-btn" onClick={toggleTheme}>
              {darkMode ? "☀️" : "🌙"}
            </button> */}
            <div
              className={`theme-toggle-switch ${darkMode ? 'dark' : 'light'}`}
              onClick={toggleTheme}
              title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
            >
              <div className="switch-knob">
                {darkMode ? '🌙' : '☀️'}
              </div>
              {/* by rajan , just above */}
            </div>
          </nav>
        </div>
      </header>
      {/* by rajan */}

      {/* Mobile cart bar */}
      {
        cart.length > 0 && (
          <div className="mobile-cart-bar">
            <Link to="/cart">
              Cart ({cart.length})
            </Link>
          </div>
        )
      }
    </>
  );
};
// by rajan
export default Header;
